'use strict';

import jQuery from 'jquery';
import FormatHelper from '../format_helper';

jQuery.formatHelper = new FormatHelper('pt-br');
